import config from '@/config';
import ajax from '@/helpers/ajax';

export const user = {
  namespaced: true,
  state: {
    info: {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      partner: null,
    },
  },
  actions: {
    setUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        ajax.get(config.apiEndpoints.userInfo)
          .then((res) => {
            if (res.status === 200) {
              commit('setUserInfo', res.data);
              resolve(res);
            }
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    },
    resetFavouritePartners({ commit }) {
      commit('resetFavouritePartners');
    },
    resetUserInfo({ commit }) {
      commit('resetUserInfo');
    },
  },
  mutations: {
    setUserInfo(state, userInfo) {
      const {
        firstName, lastName, phone, email, partner,
      } = userInfo;
      state.info = {
        firstName, lastName, phone, email, partner,
      };
    },
    resetFavouritePartners(state) {
      state.info.partner = null;
    },
    resetUserInfo(state) {
      state.info = {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        partner: null,
      };
    },
  },
  getters: {
    getUserInfo(state) {
      return state.info;
    },
    getFavouritePartner(state) {
      return state.info.partner;
    },
  },
};
